import React from "react";
import { PriceFormModal } from "components/PriceForm";
import { SpinnerBack } from "components/Spinner/Spinner";
import { useRvPriceTotalTableInfo } from "./hooks";

export const RvPriceTotalTableInfo = () => {
  const { loading, modalState, handleClose } = useRvPriceTotalTableInfo();

  return (
    <>
      {loading && <SpinnerBack />}
      {modalState.show && modalState.priceForm && !loading && (
        <PriceFormModal
          show={modalState.show}
          title="Price breakdown"
          data={[modalState.priceForm]}
          onClose={handleClose}
          isFooter={false}
          isRvPriceTableInfo
        />
      )}
    </>
  );
};
